<template>
  <CCol sm="12" lg="6" class="">
    <CCard>
      <CCardHeader>
        <h6>
          {{ $t("family.dashboard.products.title") }}
        </h6>
      </CCardHeader>
      <CCardBody>
        <div class="d-flex justify-content-center" v-if="loading">
          <CSpinner color="primary" />
        </div>
        <div v-else>
          <div class="d-flex justify-content-start" v-if="dataset.length === 0">
            {{ $t("family.dashboard.graphs.noActivity") }}
          </div>

          <CChartBar
            v-else
            :datasets="defaultDatasets"
            :labels="defaultLabels"
            :options="options"
          />
        </div>
      </CCardBody>
    </CCard>
  </CCol>
</template>

<script>
import { CChartBar } from "@coreui/vue-chartjs";
import chroma from "chroma-js";
import { apiGet } from "../../helpers/apiHelper";

export default {
  data() {
    return {
      loading: true,
      dataset: [],
      n_products: null,
      n_lots: null,
      options: {
        legend: {
          display: false,
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    async familyId(newfamilyId, oldfamilyId) {
      if (newfamilyId != oldfamilyId) {
        await this.getData();
      }
    },
  },
  methods: {
    async getData() {
      const self = this;
      this.loading = true;
      const familyId = this.familyId;

      const response = await apiGet("role_family_dash_pp", [familyId]);

      if (response && response.status === 200) {
        self.loading = false;
        self.dataset = response.data.data || [];
        self.loading = false;
      }
    },
  },
  components: {
    CChartBar,
  },
  computed: {
    familyId() {
      return this.$store.state.connections.current.family.id;
    },
    defaultDatasets() {
      let list_products = [];
      this.dataset.forEach(function (data, index) {
        // console.log(data, index);
        list_products.push(data.value);
      });
      let list_colors = [];
      let scale = chroma.scale("Spectral"); //chroma.cubehelix()//.scale(['#f00','#0f0','#00f','#f00']).mode('hsl');
      list_products.forEach(function (data, index) {
        // console.log(data, index);

        // console.log(index, list_products.length, 1/list_products.length*index)
        list_colors.push(scale((1 / list_products.length) * index).hex());
      });
      return [
        {
          backgroundColor: list_colors,
          data: list_products,
        },
      ];
    },
    defaultLabels() {
      let list_labels = [];
      this.dataset.forEach(function (data, index) {
        list_labels.push(data.label);
      });
      return list_labels;
    },
  },
};
</script>
